import React from 'react';

import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { linkTo } from '@storybook/addon-links';

import { Welcome } from '@storybook/react/demo';

storiesOf('Welcome', module).add('to Storybook', () => <div>
  <h1>Welcome to Storybook</h1>
  Stories can be used for development and validation.
</div>);




// WEBPACK FOOTER //
// ./src/01-welcome.stories.jsx